import { Component, OnInit, Inject } from '@angular/core';
import { IWidget, RolesService } from '../roles.service';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'app-roles-form',
  templateUrl: './roles-form.component.html',
  styleUrls: ['./roles-form.component.scss']
})
export class RolesFormComponent implements OnInit {

  dataGroup: UntypedFormGroup;
  title: string = '';
  widgets: IWidget[] = [];
  widgetsEx;
  btnTitle: string = '';
  groupValuesChanges: boolean = false;
  displayedColumns = ['select', 'letter', 'title'];
  selection = new SelectionModel<IWidget>(true, []);

  constructor(
    public dialogRef: MatDialogRef<RolesFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private service: RolesService,
    private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.dataGroup = this.createForm();
    if (this.data.type === 'edit') {
      this.title = 'Редактировать';
      this.btnTitle = 'Обновить';
    }
    if (this.data.type === 'create') {
      this.title = 'Создать новую роль';
      this.btnTitle = 'Создать';
    }
    this.widgets = this.data.widgets;
    this.widgetsEx = new MatTableDataSource<IWidget>(this.widgets);
    this.data.data.widgets.forEach(fw => {
      let selWid = this.widgets.find(f => f.id == fw);
      this.selection.select(selWid);
    });
  }

  createForm() {
    const group = this.fb.group({});
    for (let k in this.data.data) {
      const control = this.fb.control(
        this.data.data[k],
      );
      group.addControl(k, control);
    };
    group.controls["name"].setValidators(Validators.required);
    return group;
  }

  addValidations(validations: any) {
    if (validations.length > 0) {
      const validList = [];
      validations.forEach(valid => {
        validList.push(valid.validator);
      });
      return Validators.compose(validList);
    }
    return null;
  }

  save(): void {
    let selectedWidgets = this.selection.selected.map(sel => {
      if(sel != undefined) {
        return sel.id
      }
    });

    this.dataGroup.value.widgets = selectedWidgets;
    if (this.btnTitle === 'Создать') {
      if(this.dataGroup.valid) {
        this.service.createRole(this.dataGroup.value).subscribe(res => {
          this.snackBar.open('Новая роль успешно создана!', '', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['snackbar-succes']
          });
          this.dialogRef.close('cool');
        });
      }
    } else {
      if (this.dataGroup.valid) {
        this.service.updateRole(this.dataGroup.value).subscribe(res => {
          this.snackBar.open('Роль успешно обновлена!', '', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'right',
            panelClass: ['snackbar-succes']
          });
          this.dialogRef.close('cool');
        });
      }
    }
  }

  getWidgetTitle(id: number): string {
    if (id != undefined) {
      return this.widgets.find(f => f.id === id).title;
    }
  }

  compareObjects(o1: any, o2: any) {
    if (o1 == o2)
      return true;
    else return false
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.widgetsEx.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.widgetsEx.data.forEach(row => this.selection.select(row));
  }

  selectRow(row) {
    if (this.selection.selected.indexOf(row) == -1) {
      this.selection.select(row);
    } else {
      this.selection.deselect(row);
    }
  }

}
